// extracted by mini-css-extract-plugin
module.exports = {"dataTable":"LocationGeoDetail_dataTable__UUvcf"};